import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  navigationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'flex-end',
    justifyItems: 'flex-end',
    marginLeft:'21px'
  },
  counter: {
    color: theme.palette.grey.grey500,
    fontSize: '12px',
    marginRight: '12px'
  },
  navigation: {
    display: 'flex',
    cursor: 'pointer',
    userSelect:'none',
  },
  navigationArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.grey.grey200}`,
    height: '32px',
    width: '46px',
    '&:hover': {
      background: theme.palette.grey.grey100
    },
    '&:active': {
      background: theme.palette.grey.grey200
    }
  },
  next: {
    borderRadius: '0px 10px 10px 0px',
  },
  previous: {
    borderRadius: '10px 0px 0px 10px',
    '& img': {
      transform: 'rotate(180deg)'
    },
  },
}));

export default useStyles;
